import Agent from '@bredbandskollen/agent';
import { FunctionalLogger, Stores } from 'local/Logger';

const logger = FunctionalLogger('bridge');

export default class Bridge {
	constructor() {
		this.name = 'web';
		this.ready = true;

		this.messages = [];
		this.messageCallbacks = [];

		this.connection = new Agent(
			{
				url: window.bredbandskollen.backend,
				protocol: 'https',
			},
			(event, args) => {
				logger.log('agent', { event, args });
				this.messageCallbacks.forEach((callback) => {
					callback({ event, args });
				});
			},
		);
	}

	dispatchMessages() {
		this.messages.forEach((message) => {
			this.connection.send(message.method, message.args);
			logger.log('client', message);
		});
	}

	send(e) {
		if (!this.ready) {
			this.messages.push(e);
			logger.log('queue', e);
		} else {
			this.dispatchMessages();
			this.connection.send(e.method, e.args);
			logger.log('client', e);
		}
	}

	onMessage(callback) {
		this.messageCallbacks.push(callback);
	}
}

const { bridge } = Stores;

if (bridge) {
	bridge.on('INFO', (context, e) => {
		let color;

		switch (context) {
			case 'client':
				color = '#4497c3';
				break;
			case 'agent':
				color = '#f58e8e';
				break;
			default:
				color = '#000';
				break;
		}

		console.log(
			`%c ${context} sent`,
			`color: ${color}`,
			context === 'agent' ? e.event : e.method,
			e.args,
		);
	});
}
